import * as PropTypes from 'prop-types';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import { IconCheckmark, IconClose, IconInformationOutline } from '../Icons';

const PatientInvitationRequests = ({ invitationRequests, onInvite, onDelete, onClick }) => {
  const { t } = useTranslation('components');

  const count = invitationRequests.length;

  if (count > 0) {
    return (
      <div data-component="PhysicianWelcomeScreen__PatientInvitationRequests" className="mb-8">
        <h2 className="font-semibold text-xl mb-2 text-slate-500">
          {t('patient_invitation_requests.title')} {count > 0 && <>({count > 9 ? '9+' : count})</>}
        </h2>
        <div className="min-w-0">
          <div className="h-full w-full mb-4">
            <div className="lg:flex lg:flex-col">
              {invitationRequests &&
                invitationRequests.map((inv, index) => {
                  if (index < 3) {
                    return (
                      <div
                        key={inv.id}
                        className="flex lg:py-4 flex-1 lg:text-sm lg:border-l-none lg:border-0 pl-2 lg:pl-0 my-2 lg:my-0 lg:border-t truncate lg:border-r lg:border-l lg:bg-white  lg:last:border-b"
                      >
                        <div className="flex flex-col lg:flex-row lg:ml-4 lg:w-8/12 mr-4 lg:mr-0 truncate">
                          <div className="flex items-center mt-1 lg:mt-0 lg:w-1/4 truncate text-slate-500">
                            {inv.createdAt}
                          </div>
                          <div className="lg:w-1/4 flex items-center truncate font-semibold">
                            {inv.name}
                          </div>
                          <div className="lg:w-1/4 flex items-center truncate">
                            {t('patient_invitation_requests.date_of_birth_short')}
                            {inv.dateOfBirth}
                          </div>
                          <div className="lg:w-1/4 flex items-center truncate">{inv.email}</div>
                        </div>
                        <div className="flex-grow" />
                        <div className="flex items-center">
                          <Button
                            onClick={() => onInvite({ id: inv.id })}
                            className="lg:hidden"
                            shape="square"
                            size="sm"
                          >
                            <IconCheckmark size="4" />
                          </Button>
                          <Button
                            onClick={() => onInvite({ id: inv.id })}
                            className="hidden lg:inline"
                          >
                            {t('patient_invitation_requests.invite')}
                          </Button>
                          <button
                            onClick={() => onDelete({ id: inv.id })}
                            type="button"
                            className="text-slate-600 hover:text-slate-500 mx-8 focus:outline-none"
                          >
                            <IconClose size="4" />
                          </button>
                        </div>
                      </div>
                    );
                  }
                  return null;
                })}
              {invitationRequests.length === 0 && (
                <div className="flex-1 flex flex-col items-center justify-center py-16 lg:border-t">
                  <div className="italic">{t('patient_invitation_requests.empty_state')}</div>
                  <div className="mt-6 flex">
                    <IconInformationOutline className="fill-current text-blue-500 mr-2" />
                    {t('patient_invitation_requests.info')}
                  </div>
                </div>
              )}
            </div>
            {count > 3 && (
              <button
                className="w-full border-b border-l border-r border-t lg:border-t-0 flex-wrap flex justify-center py-4 bg-slate-50 cursor-pointer group hover:bg-slate-100"
                onClick={e => {
                  e.preventDefault();
                  onClick();
                }}
                type="button"
              >
                {t('physician_welcome_screen.invitation_requests.unread', {
                  rest: count > 9 ? '9+' : `+ ${count - 3}`,
                })}
                <span className="text-blue-500 ml-1 group-hover:underline">
                  {t('physician_welcome_screen.invitation_requests.link')}
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
  return null;
};

PatientInvitationRequests.defaultProps = {
  invitationRequests: [],
  onInvite: () => {},
  onDelete: () => {},
  onClick: () => {},
};

PatientInvitationRequests.propTypes = {
  invitationRequests: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      dateOfBirth: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }),
  ),
  onInvite: PropTypes.func,
  onDelete: PropTypes.func,
  onClick: PropTypes.func,
};

export default PatientInvitationRequests;
